export default {
    unknownUser: 'Utilisateur Inconnu',
    today: "Aujourd'hui",
    previous: 'Précédent',
    next: 'Suivant',
    month: 'Mois',
    week: 'Semaine',
    day: 'Jour',
    agenda: 'Agenda',
    date: 'Date',
    time: 'Heure',
    event: 'Événement',
    allDay: 'Toute la journée',
    noEventsInRange: 'Aucun événement dans cette plage',
    noReservations: 'Aucune réservation à afficher',
    showMore: '+ {{count}} de plus',
    work_week: 'Semaine de travail',
    yesterday: 'Hier',
    tomorrow: 'Demain',
    from: 'De',
    to: 'À',
    reservedBy: 'Réservé par {{user}}',
    borrowedBy: 'Emprunté par {{user}}',
    loadingReservations: 'Chargement des réservations...',
    errorLoadingReservations: 'Erreur lors du chargement des réservations',
    selectTimeSlot: 'Sélectionnez un créneau pour créer une réservation',
    viewReservationDetails: 'Cliquez pour voir les détails de la réservation',
    viewBorrowingDetails: 'Cliquez pour voir les détails de l\'emprunt',
    timezone: 'Heures affichées en heure de Paris (CEST/CET)',
};
